import { render, staticRenderFns } from "./CopyRestrictionsFromRatePlanWizard.vue?vue&type=template&id=4ac4e4ec&scoped=true&"
import script from "./CopyRestrictionsFromRatePlanWizard.vue?vue&type=script&lang=js&"
export * from "./CopyRestrictionsFromRatePlanWizard.vue?vue&type=script&lang=js&"
import style0 from "./CopyRestrictionsFromRatePlanWizard.vue?vue&type=style&index=0&id=4ac4e4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac4e4ec",
  null
  
)

export default component.exports